export enum RewardType {
    Gold,
    Silver,
    Bronze,
    None
}